/* eslint-disable react/prop-types */
import React from "react";

export const PasswordEyeOpen = ({ width, className }) => (
   <svg className={className} id="Suche" width={width} height="18.112" viewBox="0 0 26.564 18.112">
      <defs>
         <clipPath id="clip-path">
            <path
               id="Eye"
               d="M13.283,18.112a14.167,14.167,0,0,1-8.122-2.54A14.3,14.3,0,0,1,0,9.056a14.27,14.27,0,0,1,26.564,0,14.288,14.288,0,0,1-5.16,6.516A14.165,14.165,0,0,1,13.283,18.112Zm0-15.094a6.038,6.038,0,1,0,6.037,6.038A6.045,6.045,0,0,0,13.283,3.018Zm0,9.66a3.622,3.622,0,1,1,3.622-3.622A3.627,3.627,0,0,1,13.283,12.679Z"
               transform="translate(0 0)"
               fill="#6c727c"
            />
         </clipPath>
      </defs>
      <path
         id="Eye-2"
         d="M13.283,18.112a14.167,14.167,0,0,1-8.122-2.54A14.3,14.3,0,0,1,0,9.056a14.27,14.27,0,0,1,26.564,0,14.288,14.288,0,0,1-5.16,6.516A14.165,14.165,0,0,1,13.283,18.112Zm0-15.094a6.038,6.038,0,1,0,6.037,6.038A6.045,6.045,0,0,0,13.283,3.018Zm0,9.66a3.622,3.622,0,1,1,3.622-3.622A3.627,3.627,0,0,1,13.283,12.679Z"
         transform="translate(0 0)"
         fill="#6c727c"
      />
   </svg>
);

export const AccordionIcon = () => (
   <svg width="14" height="10" viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
         d="M6.12961 8.90558C6.5297 9.4356 7.32577 9.4356 7.72586 8.90558L13.0793 1.81375C13.5766 1.15491 13.1066 0.211259 12.2812 0.211259H1.57431C0.748836 0.211259 0.278848 1.1549 0.776186 1.81374L6.12961 8.90558Z"
         fill="#838383"
      />
   </svg>
);

export const PasswordEyeInactive = ({ width, className }) => (
   <svg
      className={className}
      id="Suche"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height="18.112"
      viewBox="0 0 26.564 18.112"
   >
      <defs>
         <clipPath id="clip-path">
            <path
               id="Eye"
               d="M13.283,18.112a14.167,14.167,0,0,1-8.122-2.54A14.3,14.3,0,0,1,0,9.056a14.27,14.27,0,0,1,26.564,0,14.288,14.288,0,0,1-5.16,6.516A14.165,14.165,0,0,1,13.283,18.112Zm0-15.094a6.038,6.038,0,1,0,6.037,6.038A6.045,6.045,0,0,0,13.283,3.018Zm0,9.66a3.622,3.622,0,1,1,3.622-3.622A3.627,3.627,0,0,1,13.283,12.679Z"
               transform="translate(0 0)"
               fill="#dfe2e6"
            />
         </clipPath>
      </defs>
      <path
         id="Eye-2"
         dataname="Eye"
         d="M13.283,18.112a14.167,14.167,0,0,1-8.122-2.54A14.3,14.3,0,0,1,0,9.056a14.27,14.27,0,0,1,26.564,0,14.288,14.288,0,0,1-5.16,6.516A14.165,14.165,0,0,1,13.283,18.112Zm0-15.094a6.038,6.038,0,1,0,6.037,6.038A6.045,6.045,0,0,0,13.283,3.018Zm0,9.66a3.622,3.622,0,1,1,3.622-3.622A3.627,3.627,0,0,1,13.283,12.679Z"
         transform="translate(0 0)"
         fill="#dfe2e6"
      />
   </svg>
);

export const Facebook = () => (
   <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
         d="M12.7439 18.0006V11.0586H15.0689L15.4167 8.35998H12.7439V6.63795C12.7439 5.85666 12.9612 5.32351 14.0813 5.32351H15.5103V2.90987C14.8185 2.83647 14.1232 2.80088 13.4276 2.80324C11.3677 2.80324 9.95758 4.06088 9.95758 6.37088V8.35998H7.62766V11.0586H9.95758V18.0006H1.38131C1.11701 18.0006 0.863536 17.8956 0.676647 17.7087C0.489758 17.5218 0.384766 17.2683 0.384766 17.004V1.05929C0.384766 0.794989 0.489758 0.541514 0.676647 0.354626C0.863536 0.167737 1.11701 0.0627441 1.38131 0.0627441H17.326C17.5903 0.0627441 17.8438 0.167737 18.0307 0.354626C18.2176 0.541514 18.3226 0.794989 18.3226 1.05929V17.004C18.3226 17.2683 18.2176 17.5218 18.0307 17.7087C17.8438 17.8956 17.5903 18.0006 17.326 18.0006H12.7439Z"
         fill="#6C726F"
      />
   </svg>
);

export const LinkedIn = () => (
   <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
         d="M16.0379 15.3488H13.3821V11.1862C13.3821 10.1936 13.3622 8.91605 11.9969 8.91605C10.6127 8.91605 10.4014 9.99631 10.4014 11.1134V15.3488H7.74463V6.78943H10.2958V7.95538H10.3307C10.6874 7.28371 11.5544 6.57318 12.8499 6.57318C15.5406 6.57318 16.0389 8.34503 16.0389 10.65V15.3488H16.0379ZM4.74503 5.61848C4.54229 5.61875 4.34149 5.57899 4.15414 5.5015C3.9668 5.424 3.79659 5.31029 3.65327 5.16689C3.50996 5.02348 3.39636 4.8532 3.31898 4.6658C3.24161 4.4784 3.20198 4.27758 3.20238 4.07484C3.20258 3.76973 3.29324 3.47153 3.46292 3.21795C3.63259 2.96437 3.87365 2.7668 4.1556 2.65023C4.43756 2.53365 4.74776 2.5033 5.04696 2.56302C5.34617 2.62273 5.62095 2.76983 5.83656 2.98572C6.05216 3.2016 6.19891 3.47657 6.25824 3.77585C6.31757 4.07514 6.28682 4.38529 6.16987 4.6671C6.05293 4.94891 5.85505 5.18971 5.60125 5.35906C5.34746 5.5284 5.04914 5.61868 4.74403 5.61848H4.74503ZM6.07642 15.3488H3.41265V6.78943H6.07741V15.3488H6.07642ZM17.3683 0.0627441H2.08027C1.34681 0.0627441 0.755859 0.64074 0.755859 1.35526V16.708C0.755859 17.4226 1.34781 18.0006 2.07927 18.0006H17.3643C18.0958 18.0006 18.6937 17.4226 18.6937 16.708V1.35526C18.6937 0.64074 18.0958 0.0627441 17.3643 0.0627441H17.3673H17.3683Z"
         fill="#6C726F"
      />
   </svg>
);

export const Instagram = () => (
   <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
         d="M10.0963 0.0661011C12.8039 0.0661011 13.1418 0.0760665 14.2041 0.125894C15.2654 0.175721 15.9879 0.342144 16.6237 0.589288C17.2814 0.84241 17.8355 1.18522 18.3896 1.7383C18.8963 2.23647 19.2884 2.83908 19.5386 3.50418C19.7847 4.13898 19.9522 4.86247 20.002 5.9238C20.0488 6.98611 20.0618 7.32394 20.0618 10.0316C20.0618 12.7392 20.0518 13.077 20.002 14.1393C19.9522 15.2006 19.7847 15.9231 19.5386 16.5589C19.2891 17.2244 18.8969 17.8272 18.3896 18.3248C17.8913 18.8314 17.2887 19.2234 16.6237 19.4738C15.9889 19.72 15.2654 19.8874 14.2041 19.9372C13.1418 19.9841 12.8039 19.997 10.0963 19.997C7.3887 19.997 7.05087 19.987 5.98855 19.9372C4.92723 19.8874 4.20474 19.72 3.56894 19.4738C2.90357 19.2242 2.30086 18.832 1.80306 18.3248C1.29623 17.8267 0.90411 17.2241 0.654046 16.5589C0.406903 15.9241 0.240479 15.2006 0.190652 14.1393C0.143814 13.077 0.130859 12.7392 0.130859 10.0316C0.130859 7.32394 0.140825 6.98611 0.190652 5.9238C0.240479 4.86148 0.406903 4.13998 0.654046 3.50418C0.903418 2.83867 1.29563 2.2359 1.80306 1.7383C2.30101 1.23129 2.90368 0.839151 3.56894 0.589288C4.20474 0.342144 4.92624 0.175721 5.98855 0.125894C7.05087 0.0790561 7.3887 0.0661011 10.0963 0.0661011ZM10.0963 5.04883C8.77481 5.04883 7.50744 5.57379 6.57299 6.50824C5.63855 7.44268 5.11359 8.71005 5.11359 10.0316C5.11359 11.3531 5.63855 12.6204 6.57299 13.5549C7.50744 14.4893 8.77481 15.0143 10.0963 15.0143C11.4178 15.0143 12.6852 14.4893 13.6196 13.5549C14.5541 12.6204 15.079 11.3531 15.079 10.0316C15.079 8.71005 14.5541 7.44268 13.6196 6.50824C12.6852 5.57379 11.4178 5.04883 10.0963 5.04883ZM16.5739 4.79969C16.5739 4.46932 16.4426 4.15247 16.209 3.91886C15.9754 3.68525 15.6586 3.55401 15.3282 3.55401C14.9978 3.55401 14.681 3.68525 14.4473 3.91886C14.2137 4.15247 14.0825 4.46932 14.0825 4.79969C14.0825 5.13007 14.2137 5.44691 14.4473 5.68052C14.681 5.91413 14.9978 6.04537 15.3282 6.04537C15.6586 6.04537 15.9754 5.91413 16.209 5.68052C16.4426 5.44691 16.5739 5.13007 16.5739 4.79969ZM10.0963 7.04192C10.8892 7.04192 11.6496 7.3569 12.2103 7.91756C12.771 8.47823 13.086 9.23866 13.086 10.0316C13.086 10.8245 12.771 11.5849 12.2103 12.1455C11.6496 12.7062 10.8892 13.0212 10.0963 13.0212C9.30341 13.0212 8.54299 12.7062 7.98232 12.1455C7.42166 11.5849 7.10668 10.8245 7.10668 10.0316C7.10668 9.23866 7.42166 8.47823 7.98232 7.91756C8.54299 7.3569 9.30341 7.04192 10.0963 7.04192Z"
         fill="#6C726F"
      />
   </svg>
);

export const YouTube = () => (
   <svg width="21" height="17" viewBox="0 0 21 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
         d="M19.9735 2.54864C20.429 4.32448 20.429 8.03163 20.429 8.03163C20.429 8.03163 20.429 11.7388 19.9735 13.5146C19.7204 14.4962 18.98 15.2685 18.0422 15.5296C16.3391 16.004 10.4635 16.004 10.4635 16.004C10.4635 16.004 4.59086 16.004 2.88477 15.5296C1.94304 15.2646 1.2036 14.4932 0.953468 13.5146C0.498047 11.7388 0.498047 8.03163 0.498047 8.03163C0.498047 8.03163 0.498047 4.32448 0.953468 2.54864C1.20659 1.56704 1.94702 0.794716 2.88477 0.533621C4.59086 0.059265 10.4635 0.0592651 10.4635 0.0592651C10.4635 0.0592651 16.3391 0.059265 18.0422 0.533621C18.984 0.798702 19.7234 1.57003 19.9735 2.54864ZM8.47041 11.5195L14.4497 8.03163L8.47041 4.54372V11.5195Z"
         fill="#6C726F"
      />
   </svg>
);

export const Twitter = () => (
   <svg width="21" height="18" viewBox="0 0 21 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
         d="M20.9903 2.73427C20.2295 3.0708 19.4227 3.29181 18.5966 3.39C19.4674 2.86924 20.119 2.04966 20.4303 1.08399C19.6131 1.57031 18.7172 1.91113 17.7834 2.09549C17.1562 1.42439 16.3249 0.979321 15.4186 0.829462C14.5123 0.679603 13.5819 0.833355 12.7721 1.26681C11.9622 1.70027 11.3182 2.38915 10.9403 3.22636C10.5623 4.06357 10.4715 5.00219 10.6821 5.89631C9.02491 5.81325 7.40375 5.38262 5.92384 4.63236C4.44392 3.8821 3.13833 2.82899 2.09183 1.54141C1.72141 2.17765 1.52675 2.90092 1.52779 3.63714C1.52779 5.08214 2.26324 6.35871 3.38136 7.10612C2.71966 7.08529 2.07253 6.90659 1.49391 6.58493V6.63675C1.4941 7.59911 1.82712 8.53179 2.43649 9.27666C3.04585 10.0215 3.89407 10.5327 4.83731 10.7236C4.22306 10.89 3.57898 10.9146 2.95384 10.7953C3.21979 11.6237 3.73813 12.3481 4.4363 12.8673C5.13446 13.3864 5.97749 13.6741 6.84735 13.6903C5.98282 14.3693 4.99295 14.8712 3.93433 15.1673C2.8757 15.4635 1.76908 15.5481 0.677734 15.4163C2.58283 16.6415 4.80054 17.2919 7.06559 17.2898C14.732 17.2898 18.9245 10.9388 18.9245 5.43093C18.9245 5.25155 18.9195 5.07018 18.9115 4.89279C19.7276 4.303 20.4319 3.57239 20.9913 2.73527L20.9903 2.73427Z"
         fill="#6C726F"
      />
   </svg>
);

export const Gradient1 = ({ style }) => (
   <svg
      style={style}
      width="623"
      height="582"
      viewBox="0 0 623 582"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
   >
      <g filter="url(#filter0_f_1838_2329)">
         <path
            d="M200.473 200.203H382.163C404.254 200.203 422.163 218.111 422.163 240.203V341.981C422.163 364.072 404.254 381.981 382.163 381.981H240.473C218.381 381.981 200.473 364.072 200.473 341.981V200.203Z"
            fill="url(#paint0_linear_1838_2329)"
            fillOpacity="0.7"
         />
      </g>
      <defs>
         <filter
            id="filter0_f_1838_2329"
            x="0.472656"
            y="0.202637"
            width="621.689"
            height="581.778"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
         >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
            <feGaussianBlur stdDeviation="100" result="effect1_foregroundBlur_1838_2329" />
         </filter>
         <linearGradient
            id="paint0_linear_1838_2329"
            x1="417.744"
            y1="200.203"
            x2="258.519"
            y2="433.151"
            gradientUnits="userSpaceOnUse"
         >
            <stop offset="0.14728" stopColor="#FA9445" stopOpacity="0.9" />
            <stop offset="0.429952" stopColor="#C54DC0" />
            <stop offset="0.820302" stopColor="#7211D4" />
         </linearGradient>
      </defs>
   </svg>
);

export const Dots = () => (
   <svg width="164" height="85" viewBox="0 0 164 85" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="3.06031" cy="3.30897" r="2.65797" fill="url(#paint0_linear_1709_521)" />
      <circle cx="3.06031" cy="29.38" r="2.65797" fill="url(#paint1_linear_1709_521)" />
      <circle cx="3.06031" cy="55.4511" r="2.65797" fill="url(#paint2_linear_1709_521)" />
      <circle cx="3.06031" cy="81.5221" r="2.65797" fill="url(#paint3_linear_1709_521)" />
      <circle cx="29.3611" cy="3.30897" r="2.65797" fill="url(#paint4_linear_1709_521)" />
      <circle cx="29.3611" cy="29.38" r="2.65797" fill="url(#paint5_linear_1709_521)" />
      <circle cx="29.3611" cy="55.4511" r="2.65797" fill="url(#paint6_linear_1709_521)" />
      <circle cx="29.3611" cy="81.5221" r="2.65797" fill="url(#paint7_linear_1709_521)" />
      <circle cx="55.6619" cy="3.30897" r="2.65797" fill="url(#paint8_linear_1709_521)" />
      <circle cx="55.6619" cy="29.38" r="2.65797" fill="url(#paint9_linear_1709_521)" />
      <circle cx="55.6619" cy="55.4511" r="2.65797" fill="url(#paint10_linear_1709_521)" />
      <circle cx="55.6619" cy="81.5221" r="2.65797" fill="url(#paint11_linear_1709_521)" />
      <circle cx="81.9627" cy="3.30897" r="2.65797" fill="url(#paint12_linear_1709_521)" />
      <circle cx="81.9627" cy="29.38" r="2.65797" fill="url(#paint13_linear_1709_521)" />
      <circle cx="81.9627" cy="55.4511" r="2.65797" fill="url(#paint14_linear_1709_521)" />
      <circle cx="81.9627" cy="81.5221" r="2.65797" fill="url(#paint15_linear_1709_521)" />
      <circle cx="108.263" cy="3.30897" r="2.65797" fill="url(#paint16_linear_1709_521)" />
      <circle cx="108.263" cy="29.38" r="2.65797" fill="url(#paint17_linear_1709_521)" />
      <circle cx="108.263" cy="55.4511" r="2.65797" fill="url(#paint18_linear_1709_521)" />
      <circle cx="108.263" cy="81.5221" r="2.65797" fill="url(#paint19_linear_1709_521)" />
      <circle cx="134.564" cy="3.30897" r="2.65797" fill="url(#paint20_linear_1709_521)" />
      <circle cx="134.564" cy="29.38" r="2.65797" fill="url(#paint21_linear_1709_521)" />
      <circle cx="134.564" cy="55.4511" r="2.65797" fill="url(#paint22_linear_1709_521)" />
      <circle cx="134.564" cy="81.5221" r="2.65797" fill="url(#paint23_linear_1709_521)" />
      <circle cx="160.865" cy="3.30897" r="2.65797" fill="url(#paint24_linear_1709_521)" />
      <circle cx="160.865" cy="29.38" r="2.65797" fill="url(#paint25_linear_1709_521)" />
      <circle cx="160.865" cy="55.4511" r="2.65797" fill="url(#paint26_linear_1709_521)" />
      <circle cx="160.865" cy="81.5221" r="2.65797" fill="url(#paint27_linear_1709_521)" />
      <defs>
         <linearGradient
            id="paint0_linear_1709_521"
            x1="1.7175"
            y1="-0.0421486"
            x2="7.60599"
            y2="4.13655"
            gradientUnits="userSpaceOnUse"
         >
            <stop stopColor="#7211D4" />
            <stop offset="1" stopColor="#ED9985" />
         </linearGradient>
         <linearGradient
            id="paint1_linear_1709_521"
            x1="1.7175"
            y1="26.0289"
            x2="7.60599"
            y2="30.2076"
            gradientUnits="userSpaceOnUse"
         >
            <stop stopColor="#7211D4" />
            <stop offset="1" stopColor="#ED9985" />
         </linearGradient>
         <linearGradient
            id="paint2_linear_1709_521"
            x1="1.7175"
            y1="52.0999"
            x2="7.60599"
            y2="56.2786"
            gradientUnits="userSpaceOnUse"
         >
            <stop stopColor="#7211D4" />
            <stop offset="1" stopColor="#ED9985" />
         </linearGradient>
         <linearGradient
            id="paint3_linear_1709_521"
            x1="1.7175"
            y1="78.171"
            x2="7.60599"
            y2="82.3497"
            gradientUnits="userSpaceOnUse"
         >
            <stop stopColor="#7211D4" />
            <stop offset="1" stopColor="#ED9985" />
         </linearGradient>
         <linearGradient
            id="paint4_linear_1709_521"
            x1="28.0183"
            y1="-0.0421486"
            x2="33.9068"
            y2="4.13655"
            gradientUnits="userSpaceOnUse"
         >
            <stop stopColor="#7211D4" />
            <stop offset="1" stopColor="#ED9985" />
         </linearGradient>
         <linearGradient
            id="paint5_linear_1709_521"
            x1="28.0183"
            y1="26.0289"
            x2="33.9068"
            y2="30.2076"
            gradientUnits="userSpaceOnUse"
         >
            <stop stopColor="#7211D4" />
            <stop offset="1" stopColor="#ED9985" />
         </linearGradient>
         <linearGradient
            id="paint6_linear_1709_521"
            x1="28.0183"
            y1="52.0999"
            x2="33.9068"
            y2="56.2786"
            gradientUnits="userSpaceOnUse"
         >
            <stop stopColor="#7211D4" />
            <stop offset="1" stopColor="#ED9985" />
         </linearGradient>
         <linearGradient
            id="paint7_linear_1709_521"
            x1="28.0183"
            y1="78.171"
            x2="33.9068"
            y2="82.3497"
            gradientUnits="userSpaceOnUse"
         >
            <stop stopColor="#7211D4" />
            <stop offset="1" stopColor="#ED9985" />
         </linearGradient>
         <linearGradient
            id="paint8_linear_1709_521"
            x1="54.3191"
            y1="-0.0421486"
            x2="60.2076"
            y2="4.13655"
            gradientUnits="userSpaceOnUse"
         >
            <stop stopColor="#7211D4" />
            <stop offset="1" stopColor="#ED9985" />
         </linearGradient>
         <linearGradient
            id="paint9_linear_1709_521"
            x1="54.3191"
            y1="26.0289"
            x2="60.2076"
            y2="30.2076"
            gradientUnits="userSpaceOnUse"
         >
            <stop stopColor="#7211D4" />
            <stop offset="1" stopColor="#ED9985" />
         </linearGradient>
         <linearGradient
            id="paint10_linear_1709_521"
            x1="54.3191"
            y1="52.0999"
            x2="60.2076"
            y2="56.2786"
            gradientUnits="userSpaceOnUse"
         >
            <stop stopColor="#7211D4" />
            <stop offset="1" stopColor="#ED9985" />
         </linearGradient>
         <linearGradient
            id="paint11_linear_1709_521"
            x1="54.3191"
            y1="78.171"
            x2="60.2076"
            y2="82.3497"
            gradientUnits="userSpaceOnUse"
         >
            <stop stopColor="#7211D4" />
            <stop offset="1" stopColor="#ED9985" />
         </linearGradient>
         <linearGradient
            id="paint12_linear_1709_521"
            x1="80.6198"
            y1="-0.0421486"
            x2="86.5083"
            y2="4.13655"
            gradientUnits="userSpaceOnUse"
         >
            <stop stopColor="#7211D4" />
            <stop offset="1" stopColor="#ED9985" />
         </linearGradient>
         <linearGradient
            id="paint13_linear_1709_521"
            x1="80.6198"
            y1="26.0289"
            x2="86.5083"
            y2="30.2076"
            gradientUnits="userSpaceOnUse"
         >
            <stop stopColor="#7211D4" />
            <stop offset="1" stopColor="#ED9985" />
         </linearGradient>
         <linearGradient
            id="paint14_linear_1709_521"
            x1="80.6198"
            y1="52.0999"
            x2="86.5083"
            y2="56.2786"
            gradientUnits="userSpaceOnUse"
         >
            <stop stopColor="#7211D4" />
            <stop offset="1" stopColor="#ED9985" />
         </linearGradient>
         <linearGradient
            id="paint15_linear_1709_521"
            x1="80.6198"
            y1="78.171"
            x2="86.5083"
            y2="82.3497"
            gradientUnits="userSpaceOnUse"
         >
            <stop stopColor="#7211D4" />
            <stop offset="1" stopColor="#ED9985" />
         </linearGradient>
         <linearGradient
            id="paint16_linear_1709_521"
            x1="106.921"
            y1="-0.0421486"
            x2="112.809"
            y2="4.13655"
            gradientUnits="userSpaceOnUse"
         >
            <stop stopColor="#7211D4" />
            <stop offset="1" stopColor="#ED9985" />
         </linearGradient>
         <linearGradient
            id="paint17_linear_1709_521"
            x1="106.921"
            y1="26.0289"
            x2="112.809"
            y2="30.2076"
            gradientUnits="userSpaceOnUse"
         >
            <stop stopColor="#7211D4" />
            <stop offset="1" stopColor="#ED9985" />
         </linearGradient>
         <linearGradient
            id="paint18_linear_1709_521"
            x1="106.921"
            y1="52.0999"
            x2="112.809"
            y2="56.2786"
            gradientUnits="userSpaceOnUse"
         >
            <stop stopColor="#7211D4" />
            <stop offset="1" stopColor="#ED9985" />
         </linearGradient>
         <linearGradient
            id="paint19_linear_1709_521"
            x1="106.921"
            y1="78.171"
            x2="112.809"
            y2="82.3497"
            gradientUnits="userSpaceOnUse"
         >
            <stop stopColor="#7211D4" />
            <stop offset="1" stopColor="#ED9985" />
         </linearGradient>
         <linearGradient
            id="paint20_linear_1709_521"
            x1="133.221"
            y1="-0.0421486"
            x2="139.11"
            y2="4.13655"
            gradientUnits="userSpaceOnUse"
         >
            <stop stopColor="#7211D4" />
            <stop offset="1" stopColor="#ED9985" />
         </linearGradient>
         <linearGradient
            id="paint21_linear_1709_521"
            x1="133.221"
            y1="26.0289"
            x2="139.11"
            y2="30.2076"
            gradientUnits="userSpaceOnUse"
         >
            <stop stopColor="#7211D4" />
            <stop offset="1" stopColor="#ED9985" />
         </linearGradient>
         <linearGradient
            id="paint22_linear_1709_521"
            x1="133.221"
            y1="52.0999"
            x2="139.11"
            y2="56.2786"
            gradientUnits="userSpaceOnUse"
         >
            <stop stopColor="#7211D4" />
            <stop offset="1" stopColor="#ED9985" />
         </linearGradient>
         <linearGradient
            id="paint23_linear_1709_521"
            x1="133.221"
            y1="78.171"
            x2="139.11"
            y2="82.3497"
            gradientUnits="userSpaceOnUse"
         >
            <stop stopColor="#7211D4" />
            <stop offset="1" stopColor="#ED9985" />
         </linearGradient>
         <linearGradient
            id="paint24_linear_1709_521"
            x1="159.522"
            y1="-0.0421486"
            x2="165.411"
            y2="4.13655"
            gradientUnits="userSpaceOnUse"
         >
            <stop stopColor="#7211D4" />
            <stop offset="1" stopColor="#ED9985" />
         </linearGradient>
         <linearGradient
            id="paint25_linear_1709_521"
            x1="159.522"
            y1="26.0289"
            x2="165.411"
            y2="30.2076"
            gradientUnits="userSpaceOnUse"
         >
            <stop stopColor="#7211D4" />
            <stop offset="1" stopColor="#ED9985" />
         </linearGradient>
         <linearGradient
            id="paint26_linear_1709_521"
            x1="159.522"
            y1="52.0999"
            x2="165.411"
            y2="56.2786"
            gradientUnits="userSpaceOnUse"
         >
            <stop stopColor="#7211D4" />
            <stop offset="1" stopColor="#ED9985" />
         </linearGradient>
         <linearGradient
            id="paint27_linear_1709_521"
            x1="159.522"
            y1="78.171"
            x2="165.411"
            y2="82.3497"
            gradientUnits="userSpaceOnUse"
         >
            <stop stopColor="#7211D4" />
            <stop offset="1" stopColor="#ED9985" />
         </linearGradient>
      </defs>
   </svg>
);

export const Gradient2 = ({ style }) => (
   <svg
      style={style}
      width="1272"
      height="1151"
      viewBox="0 0 1272 1151"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
   >
      <g filter="url(#filter0_f_1709_486)">
         <path
            d="M300.33 300.636H931.5C953.591 300.636 971.5 318.545 971.5 340.636V810.971C971.5 833.063 953.591 850.971 931.5 850.971H340.33C318.239 850.971 300.33 833.063 300.33 810.971V300.636Z"
            fill="url(#paint0_linear_1709_486)"
            fillOpacity="0.7"
         />
      </g>
      <defs>
         <filter
            id="filter0_f_1709_486"
            x="0.330078"
            y="0.63591"
            width="1271.17"
            height="1150.34"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
         >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
            <feGaussianBlur stdDeviation="150" result="effect1_foregroundBlur_1709_486" />
         </filter>
         <linearGradient
            id="paint0_linear_1709_486"
            x1="958.12"
            y1="300.636"
            x2="476.066"
            y2="1005.89"
            gradientUnits="userSpaceOnUse"
         >
            <stop offset="0.14728" stopColor="#FA9445" stopOpacity="0.9" />
            <stop offset="0.429952" stopColor="#C54DC0" />
            <stop offset="0.820302" stopColor="#7211D4" />
         </linearGradient>
      </defs>
   </svg>
);

export const About = ({ style }) => (
   <svg
      style={style}
      width="211"
      height="28"
      viewBox="0 0 211 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
   >
      <path
         d="M97.0281 16.2611H90.7281L89.4861 19.1771H87.0741L92.7441 6.57709H95.0481L100.736 19.1771H98.2881L97.0281 16.2611ZM96.2541 14.4251L93.8781 8.91709L91.5201 14.4251H96.2541ZM110.906 12.6251C111.602 12.8531 112.154 13.2371 112.562 13.7771C112.97 14.3051 113.174 14.9651 113.174 15.7571C113.174 16.8491 112.754 17.6951 111.914 18.2951C111.074 18.8831 109.85 19.1771 108.242 19.1771H101.978V6.57709H107.882C109.37 6.57709 110.516 6.87109 111.32 7.45909C112.124 8.03509 112.526 8.83309 112.526 9.85309C112.526 10.4771 112.382 11.0291 112.094 11.5091C111.806 11.9891 111.41 12.3611 110.906 12.6251ZM104.318 8.41309V11.8871H107.63C108.446 11.8871 109.07 11.7431 109.502 11.4551C109.946 11.1551 110.168 10.7231 110.168 10.1591C110.168 9.58309 109.946 9.15109 109.502 8.86309C109.07 8.56309 108.446 8.41309 107.63 8.41309H104.318ZM108.098 17.3411C109.91 17.3411 110.816 16.7351 110.816 15.5231C110.816 14.3111 109.91 13.7051 108.098 13.7051H104.318V17.3411H108.098ZM121.198 19.3571C119.914 19.3571 118.756 19.0811 117.724 18.5291C116.692 17.9651 115.882 17.1911 115.294 16.2071C114.706 15.2111 114.412 14.1011 114.412 12.8771C114.412 11.6531 114.706 10.5491 115.294 9.56509C115.882 8.56909 116.692 7.79509 117.724 7.24309C118.756 6.67909 119.914 6.39709 121.198 6.39709C122.482 6.39709 123.64 6.67909 124.672 7.24309C125.704 7.79509 126.514 8.56309 127.102 9.54709C127.69 10.5311 127.984 11.6411 127.984 12.8771C127.984 14.1131 127.69 15.2231 127.102 16.2071C126.514 17.1911 125.704 17.9651 124.672 18.5291C123.64 19.0811 122.482 19.3571 121.198 19.3571ZM121.198 17.3051C122.038 17.3051 122.794 17.1191 123.466 16.7471C124.138 16.3631 124.666 15.8351 125.05 15.1631C125.434 14.4791 125.626 13.7171 125.626 12.8771C125.626 12.0371 125.434 11.2811 125.05 10.6091C124.666 9.92509 124.138 9.39709 123.466 9.02509C122.794 8.64109 122.038 8.44909 121.198 8.44909C120.358 8.44909 119.602 8.64109 118.93 9.02509C118.258 9.39709 117.73 9.92509 117.346 10.6091C116.962 11.2811 116.77 12.0371 116.77 12.8771C116.77 13.7171 116.962 14.4791 117.346 15.1631C117.73 15.8351 118.258 16.3631 118.93 16.7471C119.602 17.1191 120.358 17.3051 121.198 17.3051ZM135.522 19.3571C133.782 19.3571 132.426 18.8711 131.454 17.8991C130.482 16.9151 129.996 15.5111 129.996 13.6871V6.57709H132.336V13.5971C132.336 16.0691 133.404 17.3051 135.54 17.3051C137.664 17.3051 138.726 16.0691 138.726 13.5971V6.57709H141.03V13.6871C141.03 15.5111 140.544 16.9151 139.572 17.8991C138.612 18.8711 137.262 19.3571 135.522 19.3571ZM146.275 8.55709H142.099V6.57709H152.791V8.55709H148.615V19.1771H146.275V8.55709ZM164.22 19.3571C162.48 19.3571 161.124 18.8711 160.152 17.8991C159.18 16.9151 158.694 15.5111 158.694 13.6871V6.57709H161.034V13.5971C161.034 16.0691 162.102 17.3051 164.238 17.3051C166.362 17.3051 167.424 16.0691 167.424 13.5971V6.57709H169.728V13.6871C169.728 15.5111 169.242 16.9151 168.27 17.8991C167.31 18.8711 165.96 19.3571 164.22 19.3571ZM176.551 19.3571C175.579 19.3571 174.637 19.2191 173.725 18.9431C172.825 18.6671 172.111 18.3011 171.583 17.8451L172.393 16.0271C172.909 16.4351 173.539 16.7711 174.283 17.0351C175.039 17.2871 175.795 17.4131 176.551 17.4131C177.487 17.4131 178.183 17.2631 178.639 16.9631C179.107 16.6631 179.341 16.2671 179.341 15.7751C179.341 15.4151 179.209 15.1211 178.945 14.8931C178.693 14.6531 178.369 14.4671 177.973 14.3351C177.577 14.2031 177.037 14.0531 176.353 13.8851C175.393 13.6571 174.613 13.4291 174.013 13.2011C173.425 12.9731 172.915 12.6191 172.483 12.1391C172.063 11.6471 171.853 10.9871 171.853 10.1591C171.853 9.46309 172.039 8.83309 172.411 8.26909C172.795 7.69309 173.365 7.23709 174.121 6.90109C174.889 6.56509 175.825 6.39709 176.929 6.39709C177.697 6.39709 178.453 6.49309 179.197 6.68509C179.941 6.87709 180.583 7.15309 181.123 7.51309L180.385 9.33109C179.833 9.00709 179.257 8.76109 178.657 8.59309C178.057 8.42509 177.475 8.34109 176.911 8.34109C175.987 8.34109 175.297 8.49709 174.841 8.80909C174.397 9.12109 174.175 9.53509 174.175 10.0511C174.175 10.4111 174.301 10.7051 174.553 10.9331C174.817 11.1611 175.147 11.3411 175.543 11.4731C175.939 11.6051 176.479 11.7551 177.163 11.9231C178.099 12.1391 178.867 12.3671 179.467 12.6071C180.067 12.8351 180.577 13.1891 180.997 13.6691C181.429 14.1491 181.645 14.7971 181.645 15.6131C181.645 16.3091 181.453 16.9391 181.069 17.5031C180.697 18.0671 180.127 18.5171 179.359 18.8531C178.591 19.1891 177.655 19.3571 176.551 19.3571Z"
         fill="#020202"
      />
      <rect x="0.509766" y="12.8322" width="79.6543" height="2.4258" fill="black" />
   </svg>
);

export const Star = () => (
   <svg width="31" height="27" viewBox="0 0 31 27" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
         d="M15.758 0.617188L19.245 10.375H30.5294L21.4002 16.4056L24.8872 26.1634L15.758 20.1328L6.62869 26.1634L10.1158 16.4056L0.986491 10.375H12.2709L15.758 0.617188Z"
         fill="#FFAD0D"
      />
   </svg>
);

export const FB = () => (
   <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
         d="M13.4583 2.125H3.54167C2.75896 2.125 2.125 2.75896 2.125 3.54167V13.4583C2.125 14.241 2.75896 14.875 3.54167 14.875H8.93988V9.94429H7.28025V8.01408H8.93988V6.59387C8.93988 4.94771 9.94642 4.05025 11.4155 4.05025C11.9106 4.04883 12.405 4.07433 12.8973 4.12462V5.84588H11.8858C11.0854 5.84588 10.9296 6.22412 10.9296 6.78229V8.01125H12.8421L12.5935 9.94146H10.9182V14.875H13.4583C14.241 14.875 14.875 14.241 14.875 13.4583V3.54167C14.875 2.75896 14.241 2.125 13.4583 2.125Z"
         fill="white"
      />
   </svg>
);

export const YT = () => (
   <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
         d="M17.9851 5.15516C17.7934 4.4385 17.2284 3.8735 16.5117 3.68183C15.2117 3.3335 10.0001 3.3335 10.0001 3.3335C10.0001 3.3335 4.78841 3.3335 3.48841 3.68183C2.77175 3.8735 2.20675 4.4385 2.01508 5.15516C1.66675 6.45516 1.66675 10.0002 1.66675 10.0002C1.66675 10.0002 1.66675 13.5452 2.01508 14.8452C2.20675 15.5618 2.77175 16.1268 3.48841 16.3185C4.78841 16.6668 10.0001 16.6668 10.0001 16.6668C10.0001 16.6668 15.2117 16.6668 16.5117 16.3185C17.2292 16.1268 17.7934 15.5618 17.9851 14.8452C18.3334 13.5452 18.3334 10.0002 18.3334 10.0002C18.3334 10.0002 18.3334 6.45516 17.9851 5.15516ZM8.33341 12.8868V7.1135L13.3334 10.0002L8.33341 12.8868Z"
         fill="white"
      />
   </svg>
);

export const TWI = () => (
   <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
         d="M12.4444 0H1.55556C0.696111 0 0 0.696111 0 1.55556V12.4444C0 13.3039 0.696111 14 1.55556 14H12.4444C13.3039 14 14 13.3039 14 12.4444V1.55556C14 0.696111 13.3039 0 12.4444 0ZM10.9278 5.06644C10.9278 5.13333 10.9278 5.19944 10.9278 5.33322C10.9278 7.86644 8.99422 10.8002 5.46078 10.8002C4.39444 10.8002 3.39422 10.4666 2.52778 9.93378C2.66078 9.93378 2.86144 9.93378 2.99444 9.93378C3.86089 9.93378 4.72811 9.60011 5.39467 9.13344C4.52822 9.13344 3.86167 8.53378 3.59489 7.80033C3.72789 7.80033 3.86167 7.86722 3.92856 7.86722C4.12844 7.86722 4.26222 7.86722 4.46211 7.80033C3.59567 7.60044 2.92911 6.867 2.92911 5.93367C3.19589 6.06667 3.46267 6.13356 3.79556 6.20044C3.262 5.73378 2.92911 5.20022 2.92911 4.53367C2.92911 4.2 2.996 3.86711 3.19589 3.60033C4.12922 4.73356 5.52922 5.53389 7.12911 5.6C7.12911 5.467 7.06222 5.33322 7.06222 5.13333C7.06222 4.067 7.92867 3.19978 8.99578 3.19978C9.52933 3.19978 10.0621 3.39967 10.3958 3.79944C10.8624 3.73256 11.2622 3.53267 11.5959 3.33278C11.4629 3.79944 11.1292 4.13311 10.7294 4.39911C11.1292 4.33222 11.4629 4.26611 11.8627 4.06544C11.5943 4.46678 11.2614 4.79967 10.9278 5.06644Z"
         fill="white"
      />
   </svg>
);

export const LNK = () => (
   <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
         d="M14.4001 2.3999H3.60015C2.93715 2.3999 2.40015 2.9369 2.40015 3.5999V14.3999C2.40015 15.0629 2.93715 15.5999 3.60015 15.5999H14.4001C15.0631 15.5999 15.6001 15.0629 15.6001 14.3999V3.5999C15.6001 2.9369 15.0631 2.3999 14.4001 2.3999ZM6.57255 13.1999H4.80255V7.5047H6.57255V13.1999ZM5.66955 6.6905C5.09895 6.6905 4.63755 6.2279 4.63755 5.6585C4.63755 5.0891 5.09955 4.6271 5.66955 4.6271C6.23835 4.6271 6.70095 5.0897 6.70095 5.6585C6.70095 6.2279 6.23835 6.6905 5.66955 6.6905ZM13.2025 13.1999H11.4337V10.4303C11.4337 9.7697 11.4217 8.9201 10.5139 8.9201C9.59295 8.9201 9.45135 9.6395 9.45135 10.3823V13.1999H7.68255V7.5047H9.38055V8.2829H9.40455C9.64095 7.8353 10.2181 7.3631 11.0791 7.3631C12.8713 7.3631 13.2025 8.5427 13.2025 10.0763V13.1999V13.1999Z"
         fill="white"
      />
   </svg>
);

export const INSTA = () => (
   <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
         d="M6 2.25C3.92925 2.25 2.25 3.92925 2.25 6V12C2.25 14.0707 3.92925 15.75 6 15.75H12C14.0707 15.75 15.75 14.0707 15.75 12V6C15.75 3.92925 14.0707 2.25 12 2.25H6ZM13.5 3.75C13.914 3.75 14.25 4.086 14.25 4.5C14.25 4.914 13.914 5.25 13.5 5.25C13.086 5.25 12.75 4.914 12.75 4.5C12.75 4.086 13.086 3.75 13.5 3.75ZM9 5.25C11.0707 5.25 12.75 6.92925 12.75 9C12.75 11.0707 11.0707 12.75 9 12.75C6.92925 12.75 5.25 11.0707 5.25 9C5.25 6.92925 6.92925 5.25 9 5.25ZM9 6.75C8.40326 6.75 7.83097 6.98705 7.40901 7.40901C6.98705 7.83097 6.75 8.40326 6.75 9C6.75 9.59674 6.98705 10.169 7.40901 10.591C7.83097 11.0129 8.40326 11.25 9 11.25C9.59674 11.25 10.169 11.0129 10.591 10.591C11.0129 10.169 11.25 9.59674 11.25 9C11.25 8.40326 11.0129 7.83097 10.591 7.40901C10.169 6.98705 9.59674 6.75 9 6.75Z"
         fill="white"
      />
   </svg>
);

export const ArrowLeft = () => (
   <svg
      width="15"
      height="8"
      viewBox="0 0 15 8"
      fill="red"
      xmlns="http://www.w3.org/2000/svg"
      className="bounce-right-anim"
   >
      <path
         fillRule="evenodd"
         clipRule="evenodd"
         d="M0.34082 3.99855C0.34082 3.8829 0.393499 3.77198 0.487267 3.69021C0.581035 3.60843 0.708212 3.56249 0.84082 3.56249L12.6338 3.56249L9.48682 0.818793C9.39293 0.736913 9.34019 0.625859 9.34019 0.510062C9.34019 0.394266 9.39293 0.283212 9.48682 0.201331C9.58071 0.119451 9.70805 0.0734506 9.84082 0.0734506C9.9736 0.0734506 10.1009 0.119451 10.1948 0.201331L14.1948 3.68982C14.2414 3.73032 14.2783 3.77844 14.3035 3.83142C14.3287 3.8844 14.3417 3.94119 14.3417 3.99855C14.3417 4.0559 14.3287 4.1127 14.3035 4.16568C14.2783 4.21865 14.2414 4.26677 14.1948 4.30728L10.1948 7.79576C10.1009 7.87765 9.9736 7.92365 9.84082 7.92365C9.70805 7.92365 9.58071 7.87765 9.48682 7.79576C9.39293 7.71388 9.34019 7.60283 9.34019 7.48703C9.34019 7.37124 9.39293 7.26018 9.48682 7.1783L12.6338 4.43461H0.84082C0.708212 4.43461 0.581035 4.38867 0.487267 4.30689C0.393499 4.22511 0.34082 4.1142 0.34082 3.99855Z"
         fill="white"
      />
   </svg>
);

export const TalkToHumanIcon = () => (
   <svg
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ alignSelf: "center" }}
   >
      <path
         d="M0.731914 1.24547C1.6453 0.934651 3.45378 0.573027 5.50506 1.54251C6.05873 1.83352 6.57015 2.1911 7.02652 2.60634C7.74626 2.48348 8.4876 2.42143 9.24015 2.42143C11.4924 2.42143 13.6278 2.97913 15.253 3.99144C16.0942 4.5162 16.7633 5.13836 17.2407 5.84114C17.7719 6.62449 18.0418 7.46624 18.0412 8.36939C18.0412 9.24779 17.7719 10.0907 17.2401 10.8735C16.7627 11.5769 16.0935 12.1985 15.2524 12.7232C13.6278 13.7355 11.4924 14.2926 9.23946 14.2926C8.48691 14.2926 7.74558 14.2305 7.0259 14.1077C6.56952 14.5229 6.0581 14.8805 5.50444 15.1715C3.4524 16.141 1.64468 15.7794 0.731295 15.468C0.431212 15.3656 0.339206 15.0058 0.560487 14.7894C1.20466 14.1592 2.27043 12.9131 2.00844 11.7804C0.990052 10.7949 0.437744 9.60636 0.437744 8.34529C0.437744 7.1078 0.989983 5.9193 2.00913 4.93305C2.27111 3.80042 1.20535 2.55488 0.561174 1.92467C0.339206 1.70819 0.431899 1.3478 0.731914 1.24547ZM9.14821 4.08019C5.19645 4.08019 1.99269 6.03904 1.99269 8.45509C1.99269 9.50767 2.6007 10.4741 3.61461 11.229C3.90026 12.0894 3.73289 13.0595 3.11292 14.1388C3.08335 14.1909 3.05584 14.243 3.02559 14.2945C3.55747 14.2529 4.09527 14.1146 4.6396 13.8622C5.05416 13.6412 5.4376 13.3717 5.78087 13.0601L6.39946 12.4962C7.24587 12.7115 8.17439 12.8306 9.14821 12.8306C13.0999 12.8306 16.3037 10.8724 16.3043 8.45509C16.3043 6.03904 13.0999 4.08019 9.14821 4.08019ZM5.72441 7.44961C6.30684 7.44961 6.77897 7.89374 6.77897 8.44144C6.77897 8.98914 6.30684 9.43334 5.72441 9.43334C5.14199 9.43334 4.66986 8.98921 4.66986 8.44144C4.66986 7.89374 5.14199 7.44967 5.72441 7.44967V7.44961ZM9.11926 7.44961C9.70169 7.44961 10.1739 7.89374 10.1739 8.44144C10.1739 8.98914 9.70169 9.43334 9.11933 9.43334C8.53691 9.43334 8.06471 8.98921 8.06471 8.44144C8.06471 7.89374 8.53684 7.44967 9.11933 7.44967L9.11926 7.44961ZM12.5141 7.44961C13.0959 7.44961 13.5687 7.89374 13.5687 8.44144C13.5687 8.98914 13.0965 9.43334 12.5142 9.43334C11.9318 9.43334 11.4596 8.98921 11.4596 8.44144C11.4596 7.89374 11.9317 7.44967 12.5142 7.44967L12.5141 7.44961Z"
         fill="white"
      />
   </svg>
);

export const DecorLine = () => (
   <svg
      width="369"
      height="170"
      viewBox="0 0 369 170"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
   >
      <path
         d="M368.374 158.967L367.579 169.473C367.579 169.473 339.642 142.195 240.759 122.925C141.875 103.654 121.172 95.3697 86.1983 78.0945C26.0046 48.3617 0.258545 0.162109 0.258545 0.162109L16.3825 0.162109C16.3825 0.162109 28.3453 44.8939 116.016 80.1826C203.687 115.471 280.699 106.58 368.374 158.967Z"
         fill="url(#paint0_linear_1197_297)"
      />
      <defs>
         <linearGradient
            id="paint0_linear_1197_297"
            x1="0.258549"
            y1="-7.24648"
            x2="288.879"
            y2="282.586"
            gradientUnits="userSpaceOnUse"
         >
            <stop offset="0.0223728" stopColor="#7211D4" />
            <stop offset="0.467241" stopColor="#C54DC0" />
            <stop offset="1" stopColor="#FA9445" />
         </linearGradient>
      </defs>
   </svg>
);

export const CTADecorLine = () => (
   <svg
      width="320"
      height="164"
      viewBox="0 0 320 164"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
   >
      <path
         d="M0.692566 0.440918H16.8945C16.8945 0.440918 36.4666 25.8265 122.108 45.4448C207.749 65.063 220.322 72.0461 249.045 88.7234C298.48 117.427 319.625 163.958 319.625 163.958H306.383C306.383 163.958 297.276 126.004 224.556 86.7076C151.836 47.4108 67.1599 62.4732 0.692566 0.440918Z"
         fill="url(#paint0_linear_1197_373)"
      />
      <defs>
         <linearGradient
            id="paint0_linear_1197_373"
            x1="319.625"
            y1="171.11"
            x2="44.4118"
            y2="-64.0035"
            gradientUnits="userSpaceOnUse"
         >
            <stop offset="0.0223728" stopColor="#7211D4" />
            <stop offset="0.467241" stopColor="#C54DC0" />
            <stop offset="1" stopColor="#FA9445" />
         </linearGradient>
      </defs>
   </svg>
);

export const CTADecorLineFlip = () => (
   <svg
      width="320"
      height="164"
      viewBox="0 0 320 164"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
   >
      <path
         d="M319.296 163.958H303.094C303.094 163.958 283.522 138.572 197.881 118.954C112.24 99.3359 99.6671 92.3528 70.9442 75.6756C21.5085 46.9719 0.36377 0.440674 0.36377 0.440674H13.6061C13.6061 0.440674 22.7128 38.3945 95.433 77.6913C168.153 116.988 252.829 101.926 319.296 163.958Z"
         fill="url(#paint0_linear_1197_372)"
      />
      <defs>
         <linearGradient
            id="paint0_linear_1197_372"
            x1="0.363774"
            y1="-6.71148"
            x2="275.577"
            y2="228.402"
            gradientUnits="userSpaceOnUse"
         >
            <stop offset="0.0223728" stopColor="#7211D4" />
            <stop offset="0.467241" stopColor="#C54DC0" />
            <stop offset="1" stopColor="#FA9445" />
         </linearGradient>
      </defs>
   </svg>
);

export const FooterCircle1 = () => (
   <svg
      width="501"
      height="496"
      viewBox="0 0 601 596"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
   >
      <g style={{ mixBlendMode: "lighten" }} opacity="0.2">
         <path
            d="M599.737 298.115C599.737 462.143 465.725 595.12 300.406 595.12C135.086 595.12 1.07471 462.143 1.07471 298.115C1.07471 134.087 135.086 1.10938 300.406 1.10938C465.725 1.10938 599.737 134.087 599.737 298.115Z"
            stroke="white"
         />
      </g>
   </svg>
);

export const FooterCircle2 = () => (
   <svg
      width="285"
      height="281"
      viewBox="0 0 385 381"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
   >
      <g style={{ mixBlendMode: "lighten" }} opacity="0.2">
         <path
            d="M383.777 190.452C383.777 295.196 298.201 380.115 192.629 380.115C87.0565 380.115 1.47998 295.196 1.47998 190.452C1.47998 85.7084 87.0565 0.790039 192.629 0.790039C298.201 0.790039 383.777 85.7084 383.777 190.452Z"
            stroke="white"
         />
      </g>
   </svg>
);

export const FooterCircle3 = () => (
   <svg
      width="438"
      height="434"
      viewBox="0 0 438 434"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
   >
      <g style={{ mixBlendMode: "lighten" }} opacity="0.2">
         <path
            d="M436.869 216.925C436.869 336.296 339.343 433.072 219.029 433.072C98.7163 433.072 1.18994 336.296 1.18994 216.925C1.18994 97.5549 98.7163 0.779297 219.029 0.779297C339.343 0.779297 436.869 97.5549 436.869 216.925Z"
            stroke="white"
         />
      </g>
   </svg>
);

export const FooterCircle4 = () => (
   <svg
      width="415"
      height="412"
      viewBox="0 0 415 412"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
   >
      <g style={{ mixBlendMode: "lighten" }} opacity="0.2">
         <path
            d="M414.298 205.924C414.298 319.079 321.849 410.817 207.8 410.817C93.7505 410.817 1.30176 319.079 1.30176 205.924C1.30176 92.7685 93.7505 1.03125 207.8 1.03125C321.849 1.03125 414.298 92.7685 414.298 205.924Z"
            stroke="white"
         />
      </g>
   </svg>
);
